module.exports = __webpack_public_path__ + "img/cornerLeftTop.82e15298.svg";